import { render, staticRenderFns } from "./PayOnDemandModal.vue?vue&type=template&id=285c8934&"
import script from "./PayOnDemandModal.vue?vue&type=script&lang=js&"
export * from "./PayOnDemandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports